import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient, { User } from "../../../../api/admin";

type AddClocksToUserParams = {
  userId: string;
  clockIds: string[];
};

type AddClocksToUserResponse = {
  user: User;
  token: string;
};

const useAddClockToUserMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<AddClocksToUserResponse, Error, AddClocksToUserParams>({
    mutationFn: async ({ userId, clockIds }: AddClocksToUserParams) => {
      return adminApiClient.addClocksToUser(userId, clockIds);
    },
    onSuccess: (data, variables) => {
      // Invalidate relevant queries to refresh the data
      queryClient.invalidateQueries({
        queryKey: ["user-clocks", variables.userId],
      });
    },
    onError: () => {
      queryClient.invalidateQueries({
        queryKey: ["user-clocks"],
      });
    },
  });
};

export default useAddClockToUserMutation;
